export default __webpack_public_path__ + "static/Starbust7-8c44e052a7a94fb912908c4fe74bc45c.png";